(() => {
  // Every section that uses the reveal includes this file; run it once.
  if (window.goRevealReady) return;
  window.goRevealReady = true;

  const observer =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              entry.target.classList.add("is-inview");
              observer.unobserve(entry.target);
            });
          },
          { threshold: 0.25, rootMargin: "0px 0px -10% 0px" },
        )
      : null;

  const init = (root) => {
    root.querySelectorAll("[data-go-reveal]:not(.is-inview)").forEach((el) => {
      if (observer) observer.observe(el);
      else el.classList.add("is-inview");
    });
  };

  init(document);
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
